<a class="sp-mr-16 user-avatar" *ngIf="employee" [uiParams]="uiSrefParams" uiSref="gtmhub.employees.employee">
  <ui-assignee-avatar
    [attr.aria-label]="'hi_open_user_profile' | localize : { user: employee.firstName }"
    [uiAlt]="altText"
    [fromAssigneeId]="employee.id"
    [attr.aria-describedby]="'open_user_profile' | localize"
    tabindex="0"
    uiSize="xl"></ui-assignee-avatar>
</a>
<div class="chip-wrapper" *ngIf="employee" [style]="!managedTeams.length && !memberTeams.length ? 'flex-direction: row;' : 'flex-direction: column;'">
  <div class="welcome-title" [class.welcome-title-centered]="!memberTeams.length && !managedTeams.length" data-test-id="greeting-text">
    {{ "user_greeting" | localize : { name: employee.firstName } }}
  </div>

  <div class="chip-grid">
    <div class="chip-list-title chip-list-title-manager" *ngIf="!!managedTeams.length">{{ "managing" | localize }}:</div>
    <view-more class="sp-mb-8" *ngIf="managedTeams.length" [attr.aria-describedby]="'managing' | localize" [numberOfElements]="managedTeams.length">
      <ui-chip
        class="sp-mr-8"
        *ngFor="let team of managedTeams; let i = index"
        [attr.aria-describedby]="'chip_aria_description' | localize"
        [ngStyle]="{ order: i }"
        [uiAssignee]="team"
        (click)="onTeamSelected(team.id)"></ui-chip>
    </view-more>
    <div class="chip-list-title chip-list-title-member" *ngIf="!!memberTeams.length" [style]="!managedTeams.length ? 'grid-column: 1; grid-row: 1' : ''">{{ "member_of" | localize }}:</div>
    <view-more
      class="sp-mb-8"
      *ngIf="memberTeams.length"
      [attr.aria-describedby]="'member_of' | localize"
      [style]="!managedTeams.length ? 'grid-column: 2; grid-row: 1' : ''"
      [numberOfElements]="memberTeams.length">
      <ui-chip
        class="sp-mr-8"
        *ngFor="let team of memberTeams; let i = index"
        [attr.aria-describedby]="'chip_aria_description' | localize"
        [ngStyle]="{ order: i }"
        [uiAssignee]="team"
        (click)="onTeamSelected(team.id)"></ui-chip>
    </view-more>
  </div>
</div>
